import { computed } from "vue";

import { useEmployeesOrganizationTableViewState } from "@components/EmployeesOrganizationTable/composables/useEmployeesOrganizationTableViewState";
import { useDropdownItems } from "@/composables/dropdown/useDropdownItems";
import { useEmployees } from "@/composables/employees/useEmployees";

export function useTableConfig() {
  const viewState = useEmployeesOrganizationTableViewState();
  const dropdownItems = useDropdownItems();
  const employees = useEmployees();
  const accountID = JSON.parse(localStorage.getItem("currentAccountID"));

  const tableParams = computed(() => {
    return {
      headers: [
        {
          text: "Employee",
          sortable: true,
          value: "first_name",
        },
        {
          text: "Primary",
          sortable: false,
          value: "primary",
          img: "icons/briefcase.svg",
        },
        {
          text: "Prepares for",
          sortable: false,
          value: "prepares",
          img: "icons/preparing.svg",
        },
        {
          text: "Status",
          sortable: false,
          value: "status",
        },
        {
          text: "",
          sortable: false,
          value: "chatter",
        },
        {
          text: "",
          sortable: false,
          value: "actions",
        },
      ],
      columns: [
        {
          field: "",
          component: "EmployeeCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeeCardProps(item),
          }),
          events: (item) => ({}), // No events needed - EmployeeCard handles navigation directly
        },
        {
          field: "",
          component: "EmployeeAssigmentTag",
          props: (item) => ({
            class: "my-4 custom-assign",
            ...viewState.getEmployeeAssigmentTagProps.getBasicInfo(item),
            ...viewState.getEmployeeAssigmentTagProps.getPositionInfo(item),
            ...viewState.getEmployeeAssigmentTagProps.getTypeInfo(item),
          }),
          events: (item) => ({
            onPrimaryAssign: () => {
              employees.setCurrentEmployee(item);
              viewState.openAssignmentWizard();
            },
            onClose: () => {
              employees.setCurrentEmployee(item);
              const primaryPosition = item.primary_position || item.primary_positions?.[0];
              viewState.state.relieveAssignment.currentPosition = primaryPosition || null;
              viewState.state.relieveAssignment.show = true;
              viewState.state.relieveAssignment.type = "primary";
            },
            onHandleApplyDate(date) {
              employees.setCurrentEmployee(item);
              // Handle date update for primary assignment if needed
            },
          }),
        },
        {
          field: "",
          component: "ExEmployeePrepareAssignmentCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeePrepareAssignmentCardProps.getOccupiedByInfo(
              item
            ),
            ...viewState.getEmployeePrepareAssignmentCardProps.getEmployeeInfo(
              item
            ),
            ...viewState.getEmployeePrepareAssignmentCardProps.getPositionInfo(
              item
            ),
            ...viewState.getEmployeePrepareAssignmentCardProps.getTypeInfo(
              item
            ),
          }),
          events: (item) => ({
            onPreparePosition: () => {
              employees.setCurrentEmployee(item);
              viewState.openPreparePosition();
            },
            onClose: () => {
              employees.setCurrentEmployee(item);
              viewState.state.relieveAssignment.currentPosition =
                item.preparing_for_positions?.[0] || null;
              viewState.state.relieveAssignment.show = true;
              viewState.state.relieveAssignment.type = "prepare";
            },
            onHandleApplyDate(date) {
              employees.setCurrentEmployee(item);
              // Handle date update for prepare assignment if needed
            },
          }),
        },
        {
          field: "",
          component: "EmployeeBadge",
          props: (item) => ({
            ...viewState.getStateBadgeProps(item),
          }),
        },
        {
          field: "",
          component: "ChatterIcon",
          props: (item) => ({
            class: "my-4",
            is_white: false
          }),
          events: (item) => ({
            onClick: () => {
              viewState.openEmployeeChatterModal(item);
            },
          }),
        },
        {
          field: "",
          component: "Dropdown",
          props: (item) => {
            // Ensure status is normalized to lowercase for dropdown items
            const normalizedItem = {
              ...item,
              status: item.status ? item.status.toLowerCase() : item.status,
            };
            const items = dropdownItems.getEmployeeDropdownItems(normalizedItem);
            return {
              "data-testid": "employee-operations-menu",
              translateXOffset: 12,
              translateYOffset: 30,
              isOpen: false,
              dropdownItems: Array.isArray(items) ? items : [],
            };
          },
          events: (item) => ({
            onClick: async (operation) => {
              await viewState.handleEmployeeDropdownOperation(operation, item);
            },
          }),
        },
      ],
      filters: {
        values: [],
        searchText: "",
      },
      hideTopSection: true,
      hideActiveNo: false,
      activeRecords: {
        field: "status",
        value: "active",
      },
      defaultOrderingField: "first_name",
      activeRecordsCount: 0,
      hideGridView: true,
      actionLabel: "Add Employee",
      title: "Employees Organization",
      orderingStorageKey: "employees.ordering",
      cellContainerMaxWidth: "calc(15vw + 60px)",
      getRowStyle: (item) => ({
        backgroundColor:
          item.position?.data?.status === "active" ? "#ECFDF3" : "#FFFFFF",
      }),
    };
  });
  return {
    tableParams,
  };
}
